import { Component, type ErrorInfo, type ReactNode } from "react";

import { JoinError } from "./onboarding/Onboarding";

interface ApplicationErrorBoundaryProps {
  children: ReactNode;
  onReload?: () => void;
}

interface ApplicationErrorBoundaryState {
  failed: boolean;
}

export class ApplicationErrorBoundary extends Component<
  ApplicationErrorBoundaryProps,
  ApplicationErrorBoundaryState
> {
  state: ApplicationErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): ApplicationErrorBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Application render failed.", {
      name: error.name,
      componentStack: info.componentStack,
    });
  }

  render() {
    if (this.state.failed) {
      return (
        <JoinError
          heading="SOMETHING WENT WRONG"
          actionLabel="RELOAD"
          message="Something went wrong. Reload the app and try again."
          onReset={this.props.onReload ?? (() => window.location.reload())}
        />
      );
    }
    return this.props.children;
  }
}
